import { render } from "./EditProBookingForProDialog.vue?vue&type=template&id=48f500a8"
import script from "./EditProBookingForProDialog.vue?vue&type=script&lang=js"
export * from "./EditProBookingForProDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__